<template>
  <div class="comp-desc-text">
    <div class="desc-inner-container">
      <div class="text">
        <i :class="iconClass"></i>
        <span v-if="descTexts">
          <div v-for="item in descTexts" :class="textClass">{{item}}</div>
        </span>
        <span v-else :class="textClass">
          {{descText}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['desc', 'textClass', 'iconClass'],
    data () {
      if (typeof this.desc === 'object' && this.desc.constructor === Array) {
        return {
          descText: '',
          descTexts: this.desc
        };
      }
      return {
        descText: this.desc,
        descTexts: null
      };
    }
  };
</script>

<style lang="less">
  .comp-desc-text {
    background: white;
    .desc-inner-container {
      padding: 10px 22px 0 20px;
      .text {
        background: #F8F8F8;
        min-height: 40px;
        line-height: 40px;
        padding-left: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// DescText.vue?04749ffa